class Search {

    constructor(params) {

        this.params = params;

        //Search container
        this.searchContainer = params.element;

        // Search bar.
        this.searchInput = this.searchContainer.find('input.__search-bar-input');
        this.searchButton = this.searchContainer.find('button.__search-bar-button');

        // Search results.
        this.searchResultsContainer = this.searchContainer.find('.__search-results');
        this.searchResultsList = this.searchContainer.find('.__search-results-list');
        this.searchResultsLoader = this.searchContainer.find('.__search-results-loader');
        this.searchResultsButton = this.searchContainer.find('.__search-results-button');
        this.searchResultsButtonContainer = this.searchContainer.find('.__search-button-container');     
        
        this.searchResults;
        this.searchTimeout;
        this.searchDelay = 300;

        // Cookie prefix.
        this.cookies = {
            'prefix': 'search_'
        };

        // History settings.
        this.history = {
            'max_items': this.params.history.maxItems,
        }

        // Search history.
        this.searchHistoryContainer = this.searchContainer.find('.__search-history');
        this.searchHistoryList = this.searchContainer.find('.__search-history-list');

        this.historyItems = localStorage.getItem('history') 
            ? JSON.parse(localStorage.getItem('history')) 
            : [];

        this.init();
    }

    
    init() {
        const self = this; 

        // Search input
        self.searchInput.on('keyup click', function (e) {
            e.stopPropagation();

            // set search gradient.
            if($('.search-gradient').length == 0) {
                setOverlay('header','search');
            }

            let value = self.searchValueValidation($(this).val()),
                noWhitespaceValue = value.replace(/\s+/g, '');

            if(config.website.search.search.history.enabled) {
                if(!self.searchHistoryContainer.hasClass('open') || noWhitespaceValue != 0) {

                    // Hide history
                    self.searchHistoryContainer.removeClass('open');
                }
            }

            if (noWhitespaceValue.length >= 3) {

                // width search results open and clicking on the input field we do not want to search again.
                if(e.type === 'click' && self.searchResultsContainer.hasClass('open')) {
                    return;
                }

                if (e.which == 13) {

                    if(config.website.search.search.history.enabled) {
                        self.addToHistory({
                            'title': value ?? '',
                            'id': null,
                            'url': config.url_search + '?term=' + value,
                            'image': null,
                            'type': null,
                        });
                    }

                    self.redirect(value);
                }

                if($('.header-gradient').length == 1) {
                    setOverlay('header','search');
                }

                if($('.search-gradient').length == 0) {
                    setOverlay('header','search');
                }

                // Search request.
                self.search();
                
            } else if (noWhitespaceValue.length == 0) {

                if($('.search-gradient').length == 1) {
                    setOverlay('header','search');
                }

                self.searchResultsContainer.removeClass('open');
                self.searchResultsList.removeClass('open');

                if(config.website.search.search.history.enabled) {
                    if(self.historyItems.length != 0) {
                        if($('.header-gradient').length == 1) {
                            setOverlay('header','search');
                        }
                        if($('.search-gradient').length == 0) {
                            setOverlay('header','search');
                        }

                        // width search results open and clicking on the input field we do not want to search again.
                        // console.log( self.searchHistoryContainer.hasClass('open') );
                        if(e.type === 'click' && self.searchHistoryContainer.hasClass('open')) {
                            // console.log('check');
                            return;
                        }

                        self.getHistory();
                    }
                }

            }

        });

        // Remove things when clicking on search gradient.
        $(document).on('click', '.search-gradient', function (e) {
            self.removeSearchResults();
        });

        // Voice button.
        $(document).on('click', '.voice-button', function (e) {
            self.startDictation();
        });

        
        // Search button.
        self.searchButton.on('click', function (e) {
            let searchVal = self.searchInput.val();
            if(searchVal.length >= 3) {

                if(config.website.search.search.history.enabled) {
                    self.addToHistory({
                        'title': searchVal ?? '',
                        'id': null,
                        'url': config.url_search + '?term=' + searchVal,
                        'image': null,
                        'type': null,
                    });
                }

                self.redirect(searchVal);
            }
        });

        // Search results button.
        self.searchResultsButton.on('click', function (e) {
            let searchVal = self.searchInput.val();
            if(searchVal.length >= 3) {

                if(config.website.search.search.history.enabled) {
                    self.addToHistory({
                        'title': searchVal ?? '',
                        'id': null,
                        'url': config.url_search + '?term=' + searchVal,
                        'image': null,
                        'type': null,
                    });
                }
                
                self.redirect(searchVal);
            }
        });

        if(config.website.search.search.history.enabled) {
            // Remove things when clicking on search gradient.
            $(document).on('click', '.__btn-delete-all-history', function (e) {

                self.deleteHistory('history');

                self.searchHistoryList.slideUp("fast", function() {

                    // Empty history list.
                    self.searchHistoryList.empty();

                    self.searchHistoryContainer.fadeIn("fast", function() {
                        self.searchHistoryContainer.removeClass('open');
                    });
                });

            });

            // Delete selected history item
            $(document).on('click', '.btn-delete-history-item', function (e) {
                e.preventDefault();
                e.stopPropagation();
                let item = $(this);
                
                $(this).closest('li').slideUp( "fast", function() {
                    $(this).remove();
                    self.deleteHistoryItem(item.data('delete'));
                });
            });
        }

        // Click on a search result
        $(document).on('click', '.clickable-item', function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            if(config.website.search.search.history.enabled) {
                self.addToHistory({
                    'title': $(this).data('title') ?? '',
                    'id': $(this).data('id') ?? null,
                    'url': $(this).attr('href') ?? null,
                    'image': $(this).data('image') ?? null,
                    'type': $(this).data('type') ?? null,
                });
            }

            if($(this).attr('href') != '') {
                self.redirectLink($(this).attr('href'));
            }
        });
    }

    search(searchDelay = 300) {
        const self = this;

        // remove search result items.
        self.searchResultsList.empty();

        // Open search results element.
        self.searchResultsContainer.addClass('open');
        
        // show loader
        if(!self.searchResultsLoader.hasClass('open')) {
            self.searchResultsLoader.addClass('open');
        }

        // Reset timer.
        if (self.searchTimeout) {
            clearTimeout(self.searchTimeout);
        }

        self.searchTimeout = setTimeout(function () {

            if (self.searchResults && self.searchResults.readyState != 4) {
                self.searchResults.abort();
            }

            self.searchResults = $.ajax({
                'url': config.domain + '/frontend/functions/search.php?query=' +self.searchValueValidation(self.searchInput.val())+'&action=ajax',
                'method': 'GET',
                'async': true,
                'success': function (data, status, error) {

                    // hide loader
                    if(self.searchResultsLoader.hasClass('open')) {
                        self.searchResultsLoader.removeClass('open');
                    }

                    // remove search result items.
                    self.searchResultsList.empty();

                    // set search result items.
                    if(status === 'success') {
                        self.searchResultsItems(data);
                    }

                    if(status === 'error') {
                        self.showError();
                    }
                },
                'error': function (request, status, error) {
                    if(status === 'error') {
                        self.showError();
                    }
                }
            });
        }, searchDelay);

    }

    // Search results.
    searchResultsItems(data) {
        const self = this;
        let count = 0,
            countItems = 0,
            searchItems = '';

        for (let key in data) {

            let subs = data[key].data

            if (subs.length > 0) {
                searchItems += '<li class="list-group-item px-0">';
                searchItems += '<div class="mb-0 search-title font-weight-bold">' + data[key].title + '</div>';
                for (let q in subs) {

                    // Products.
                    if(subs[q]['type'] === 'products') {
                        searchItems += `
                            <div class="d-flex align-items-center">
                                <div class="search-image">
                                    <div class="ratio ratio-1x1 ratio-contain">
                                        <div class="inner">
                                            <img 
                                                src="${config.domain}/media/products/${subs[q]['id']}/${subs[q]['extra']['image_square_src']}"
                                                onerror="this.onerror=null;this.src='${config.domain}/assets/dist/img/no-image-found.jpg'"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <a 
                                        href="${config.domain}/${subs[q]['slug_data']}?searchtype=suggest" 
                                        class="search-item mb-0 d-block text-truncate clickable-item" 
                                        data-id="${subs[q]['id']}" 
                                        data-title="${subs[q]['title']}"
                                        data-image="${config.domain}/media/products/${subs[q]['id']}/${subs[q]['extra']['image_square_src']}"
                                        data-type="${subs[q]['type']}">
                                        ${subs[q]['title']}
                                    </a>
                                </div>
                            </div>
                        `;
                    // } else if(subs[q]['type'] === 'categories') {

                    } else {
                        searchItems += `
                            <div class="d-flex align-items-center position-relative">
                                <a 
                                    href="${config.domain}/${subs[q]['slug_data']}?searchtype=suggest" 
                                    class="search-item mb-0 d-block text-truncate clickable-item" 
                                    data-id="${subs[q]['id']}" 
                                    data-title="${subs[q]['title']}"
                                    data-image="#"
                                    data-type="${subs[q]['type']}">
                                    ${subs[q]['title']}
                                </a>
                            </div>
                        `;
                    }

                    countItems++;
                }
                searchItems += '</li>';
                count++;
            }
        }

        // Show no results text.
        if (count == 0) {
            searchItems = '<li class="list-group-item px-0 mt-2 mb-0 search-item d-block text-truncate">' + self.searchContainer.data('no-results') + '</li>';
            
            // hide search button
            if(self.searchResultsButtonContainer.hasClass('open')) {
                self.searchResultsButtonContainer.removeClass('open');
            }
        } else {
            // show search button
            if(!self.searchResultsButtonContainer.hasClass('open')) {
                self.searchResultsButtonContainer.addClass('open');
            }
        }

        // Change search result button text.
        if (countItems == 1) {
            self.searchResultsButton.text(self.searchContainer.data('singular').replace('%', data.count.data));
        } else {
            self.searchResultsButton.text(self.searchContainer.data('plural').replace('%', data.count.data));
        }

        self.searchResultsList.append(searchItems);

        // show results list
        if(!self.searchResultsList.hasClass('open')) {
            self.searchResultsList.addClass('open');
        }
    }

    // Search value validation here.
    searchValueValidation(value) {
        value = value.trim() ?? '';
        return value;
    }

    removeSearchResults() {
        const self = this;
    
        self.searchResultsContainer.removeClass('open');
        self.searchResultsList.removeClass('open');
        self.searchResultsButtonContainer.removeClass('open');
        self.searchResultsList.empty();

        if(config.website.search.search.history.enabled) {
            self.searchHistoryContainer.removeClass('open');
            self.searchHistoryList.empty();
        }

        $('.search-gradient').remove();
        clearTimeout(self.searchTimeout);
    }

    showError() {
        const self = this;

        // hide loader
        if(self.searchResultsLoader.hasClass('open')) {
            self.searchResultsLoader.removeClass('open');
        }

        if(config.website.search.search.history.enabled) {
            self.searchHistoryContainer.removeClass('open');
            self.searchHistoryList.empty();
        }

        // remove search result items.
        self.searchResultsList.empty();

        self.searchResultsList.append('<li class="list-group-item px-0 mt-2 mb-0 search-item d-block text-truncate">' + self.searchContainer.data('no-results') + '</li>');
        
        // show results list
        if(!self.searchResultsList.hasClass('open')) {
            self.searchResultsList.addClass('open');
        }
    }

    // Redirect to search results page.
    redirect(value) {
        window.location = config.url_search + '?term=' + value;
    }

    // Redirect to url from search result.
    redirectLink(url) {
        window.location = url;
    }

    // BEGIN history

    // Add history to local storage.
    addToHistory(params) {
        const self = this;
        
        // Reverse array.
        self.historyItems.reverse();

        // Removes one record when max items is reached.
        if (self.historyItems.length >= this.history.max_items) {
            self.historyItems.pop();
        }

        // Reverse array.
        self.historyItems.reverse();

        // Push item to array.
        self.historyItems.push({
            'id': params.id ?? '',
            'title': params.title ?? '',
            'url': params.url ?? '',
            'image': params.image ?? '',
            'type': params.type ?? '',
        });

        // Removes dublicates.
        self.historyItems = [...new Set(self.historyItems.map(e => JSON.stringify(e)))].map(e => JSON.parse(e));

        // Update local storage.
        localStorage.setItem('history', JSON.stringify(self.historyItems));
    }

    // Get the history items from the cookie
    getHistory() {
        const self = this;

        let history = JSON.parse(localStorage.getItem('history')) ?? [],
            searchHistoryItems = '',
            searchValue = '',
            searchId = '',
            searchTitle = '',
            searchUrl = '',
            searchType = '',
            searchImage = '';
        
        // Empty history list.
        self.searchHistoryList.empty();

        // Reverse array.
        history.reverse();
        
        $.each(history, function(key, value) {
            searchId = value.id;
            searchTitle = value.title;
            searchUrl = value.url;
            searchType = value.type;
            searchImage = value.image;

            searchValue = searchTitle.replace(/\s/g, '+');
            if(searchUrl == '') {
                searchUrl = config.global.url_search+'?term='+searchValue;
            }

            if(searchType === 'products') {
                searchHistoryItems += `
                    <li class="list-group-item px-0 d-flex align-items-center">
                        <div class="search-image">
                            <div class="ratio ratio-1x1 ratio-contain">
                                <div class="inner">
                                    <img 
                                        src="${searchImage}"
                                        onerror="this.onerror=null;this.src='${config.domain}/assets/dist/img/no-image-found.jpg'"/>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <a 
                                href="${searchUrl}" 
                                class="search-item mb-0 d-block text-truncate clickable-item" 
                                data-id="${searchId}" 
                                data-title="${searchTitle}"
                                data-image="${searchImage}"
                                data-type="${searchType}">
                                ${searchTitle}
                            </a>
                        </div>
                        <span class="btn-delete-history-item ml-auto" data-delete="${searchTitle}" data-id="${searchId}">
                            <i class="fas fa-times cursor-pointer"></i>
                        </span>
                    </li>
                `;
            } else {
                searchHistoryItems += `
                    <li class="list-group-item px-0 d-flex">
                        <a href="${searchUrl}" title="${searchTitle}" class="search-item mb-0 d-block text-truncate">
                            ${searchTitle}
                        </a>
                        <span class="btn-delete-history-item ml-auto" data-delete="${searchTitle}" data-id="${searchId}">
                            <i class="fas fa-times cursor-pointer"></i>
                        </span>
                    </li>
                `;
            }


        });

        self.searchHistoryList.append(searchHistoryItems);

        // show History list
        if (!self.searchResultsContainer.hasClass('open') && 
            !self.searchHistoryContainer.hasClass('open') && 
            history.length != 0) {
            self.searchHistoryContainer.addClass('open');
        }

        return history;
    }

    // Delete 1 history item from the local storage
    deleteHistoryItem(value) {
        const self = this;

        // Delete from history items on title.
        self.historyItems = self.historyItems.filter(function(item){ 
            return item.title !== value;
        });

        // hide results element when array is empty.
        if (self.historyItems.length == 0) {
            self.removeSearchResults();
        }

        localStorage.setItem('history', JSON.stringify(self.historyItems));
    }

    // Delete the whole search history from the local storage
    deleteHistory(name) {
        const self = this;
        
        localStorage.removeItem(name);
        self.historyItems = [];
    }

    // END history


    startDictation() {
        const self = this;

        let SpeechRecognition = window.SpeechRecognition || webkitSpeechRecognition;
    
        let recognition = new SpeechRecognition();
       
        recognition.continuous = false;
        recognition.lang = `${config.language}-${config.language.toUpperCase()}`;
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;
    
        recognition.start();
    
        recognition.onresult = function (e) {
            // document.getElementById('search').value = e.results[0][0].transcript;

            self.searchInput.val(e.results[0][0].transcript);
            recognition.stop();
            // document.getElementById('search-icon').click();
            self.searchButton.trigger('click');
        };
    
        recognition.onerror = function (e) {
            recognition.stop();
        };
    
    }
}